import React from 'react'
import { T } from '@transifex/react'

export const appVersion = process.env.REACT_APP_VERSION || '1.0.0'

export const AppVersion = () => {
  return <T _str="Version: {v}" v={appVersion} />
}
